import { render } from "./EmptyRouterView.vue?vue&type=template&id=12543c1e"
import script from "./EmptyRouterView.vue?vue&type=script&lang=js"
export * from "./EmptyRouterView.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/projeto_logistica/projeto_logistica/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/EmptyRouterView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "12543c1e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('12543c1e', __exports__)) {
    console.log('reload')
    api.reload('12543c1e', __exports__)
  }
  
  module.hot.accept("./EmptyRouterView.vue?vue&type=template&id=12543c1e", () => {
    console.log('re-render')
    api.rerender('12543c1e', render)
  })

}


export default __exports__